module.exports = __webpack_public_path__ + "static/media/slider_prev_white.996cc1db.png";